import React from "react";
import { FaCode } from "react-icons/fa";
import { FaCodeFork } from "react-icons/fa6";
import { CiMail } from "react-icons/ci";
// import { CiHeart } from "react-icons/ci";


function QualityPlaceToLearn() {
  return (
    <>
      <div className="quality-place">
        <div className="quality-text">
          <h1>What is 30 Days of Code?</h1>
          <h2>
            A quality place to learn and{" "}
            <span style={{ color: "#E0245E" }}>&#10084;</span>
            <span style={{ color: "#3B82F6" }}>Problem Solving</span>
          </h2>
          <button className="btn btn-primary mt-3 text-white">Sign up Now</button>
        </div>

        <div className="quality-cards">
          <div className="card card-blue">
            <div className="card-body">
              <h5>
                <FaCode className="mr-2" /> Submit solutions in any popular languages
              </h5>
            </div>
          </div>

          <div className="card card-red">
            <div className="card-body">
              <h5>
                <FaCodeFork className="mr-2" /> Unlock a new code challenge each day
              </h5>
            </div>
          </div>

          <div className="card card-green">
            <div className="card-body">
              <h5>
                <CiMail className="mr-2" /> Learn Problem Solving Approach
              </h5>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default QualityPlaceToLearn;
